import {
    Box,
    Typography,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    TextareaAutosize,
    IconButton,
    useMediaQuery,
    TextField,
    Grid,
} from "@mui/material";
import { DataGridPro } from "@mui/x-data-grid-pro";
import React, { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { useTheme } from "@mui/material/styles";
import ForumOutlinedIcon from "@mui/icons-material/ForumOutlined";
import CollapseSection from "../../../components/ui/CollapseSection";
import CloseIcon from '@mui/icons-material/Close';
import muiConfig from '../../../assets/MuiConfig.json'

const DisplayComments = (params) => {
    const [displayComments, setDisplayComments] = useState("");
    const [userComments, setUserComments] = useState("");
    const [open, setOpen] = useState(false);
    const desiredcolor =
        params?.comments?.length > 0 &&
            params?.comments != "Default Customer quota record"
            ? "blue"
            : "black";

    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <>
            <IconButton
                onClick={() => setOpen(true)}
                title={params.comments}
            >
                {params?.comments ? (
                    <ForumOutlinedIcon title={params.comments} sx={{ color:"darkred.light" }}/>
                ) : (
                    <ForumOutlinedIcon />
                )}
            </IconButton>

            <Dialog
                disableEnforceFocus
                fullScreen={fullScreen}
                open={open}
                onClose={handleClose}
                aria-labelledby="responsive-dialog-title"
            >
                <DialogTitle id="responsive-dialog-title">Comments</DialogTitle>
                <IconButton
                    onClick={handleClose}
                    sx={{
                        position:'absolute',
                        top:10,
                        right:10,
                        zIndex:1,
                        color:'grey'
                    }}
                    >
                        <CloseIcon/>
                    </IconButton>
                <DialogContent>
                    <DialogContentText>
                        <TextareaAutosize
                            onChange={(event) => setUserComments(event.target.value)}
                            aria-label="minimum height"
                            minRows={5}
                            readOnly
                            placeholder=""
                            style={{ width: 500, fontSize: 18 }}
                            defaultValue={params.comments}
                        />
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button
                        variant="outlined"
                        onClick={handleClose}
                        size="small"
                        // style={{
                        //     background: "#286aa6",
                        //     color: "white",
                        //     borderRadius: "4px",
                        // }}
                        sx={{
                            bgcolor: "darkred.light",
                            color: "white.main",
                            textTransform: "none",
                            fontWeight: "bold",
                            "&:hover": {
                              bgcolor: "darkred.main",
                              color: "white.main",
                            },
                          }}
                    >
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};

function getColumns(periodDepletionModel) {
    if(periodDepletionModel?.toLowerCase() === "none") {
    const columns  = [
         { field: "customerName", headerName: "Customer / CG", flex:1 ,},
         { field: "customerNumber", headerName: "Customer Number", flex:1, },
         { field: "skuName", headerName: "SKU / PG", flex:1,},
         { field: "skuNumb", headerName: "SKU Number", flex:1 ,},
         { field: "initialQuota", headerName: "Initial Quota", flex:1, align:"center", headerAlign:"center",
            valueFormatter: (params) => {
                const formattedValue = params.value?.toLocaleString('en-US');
                return formattedValue;
            }
         },
         { field: "safetyMargin", headerName: "Safety Margin", flex:1, align:"center", headerAlign:"center",
            valueFormatter: (params) => {
                const formattedValue = params.value?.toLocaleString('en-US');
                return formattedValue;
            }
         },
         { field: "adjustment", headerName: "Adjustment", flex:1, align:"center", headerAlign:"center",
            valueFormatter: (params) => {
                const formattedValue = params.value?.toLocaleString('en-US');
                return formattedValue;
            } 
         },
         { field: "totalQuota", headerName: "Total Quota", flex:1, align:"center", headerAlign:"center",
            valueFormatter: (params) => {
                const formattedValue = params.value?.toLocaleString('en-US');
                return formattedValue;
            } 
         },
         {
             field: "customerQuotaComments",
             headerName: "Customer Quota Comments",
             flex:1,
             align:"center",
             headerAlign:"center",
             renderCell: (cellValues) => {
             return <DisplayComments readonly comments={cellValues.value} />;
             },
         },
     ];
     return columns;
    }else if(periodDepletionModel?.toLowerCase() === "biweekly") {
        const columns  = [
             { field: "customerName", headerName: "Customer / CG", flex:1 },
             { field: "customerNumber", headerName: "Customer Number", flex:1 },
             { field: "skuName", headerName: "SKU / PG", flex:1 },
             { field: "skuNumb", headerName: "SKU Number", flex:1 },
             { field: "initialQuota", headerName: "Initial Quota", flex:1, align:"center", headerAlign:"center",
                valueFormatter: (params) => {
                    const formattedValue = params.value?.toLocaleString('en-US');
                    return formattedValue;
                } 
             },
             { field: "safetyMargin", headerName: "Safety Margin", flex:1, align:"center", headerAlign:"center",
                valueFormatter: (params) => {
                    const formattedValue = params.value?.toLocaleString('en-US');
                    return formattedValue;
                } 
             },
             { field: "adjustment", headerName: "Adjustment", flex:1, align:"center", headerAlign:"center",
                valueFormatter: (params) => {
                    const formattedValue = params.value?.toLocaleString('en-US');
                    return formattedValue;
                } 
             },
             { field: "totalQuota", headerName: "Total Quota", flex:1, align:"center", headerAlign:"center",
                valueFormatter: (params) => {
                    const formattedValue = params.value?.toLocaleString('en-US');
                    return formattedValue;
                } 
             },
             { field: "weekly1", headerName: "First Half", flex:1, align:"center", headerAlign:"center",
                valueFormatter: (params) => {
                    const formattedValue = params.value?.toLocaleString('en-US');
                    return formattedValue;
                } 
             },
             { field: "weekly2", headerName: "Second Half", flex:1, align:"center", headerAlign:"center",
                valueFormatter: (params) => {
                    const formattedValue = params.value?.toLocaleString('en-US');
                    return formattedValue;
                } 
             },
             {
                 field: "customerQuotaComments",
                 headerName: "Customer Quota Comments",
                 flex:1,
                 align:"center",
                 headerAlign:"center",
                 renderCell: (cellValues) => {
                 return <DisplayComments readonly comments={cellValues.value} />;
                 },
             },
         ];
         return columns;
    }else{
        const columns  = [
             { field: "customerName", headerName: "Customer / CG", flex:1 },
             { field: "customerNumber", headerName: "Customer Number", flex:1 },
             { field: "skuName", headerName: "SKU / PG", flex:1 },
             { field: "skuNumb", headerName: "SKU Number", flex:1 },
             { field: "initialQuota", headerName: "Initial Quota", flex:1, align:"center", headerAlign:"center",
                valueFormatter: (params) => {
                    const formattedValue = params.value?.toLocaleString('en-US');
                    return formattedValue;
                } 
             },
             { field: "safetyMargin", headerName: "Safety Margin", flex:1, align:"center", headerAlign:"center",
                valueFormatter: (params) => {
                    const formattedValue = params.value?.toLocaleString('en-US');
                    return formattedValue;
                } 
             },
             { field: "adjustment", headerName: "Adjustment", flex:1, align:"center", headerAlign:"center",
                valueFormatter: (params) => {
                    const formattedValue = params.value?.toLocaleString('en-US');
                    return formattedValue;
                } 
             },
             { field: "totalQuota", headerName: "Total Quota", flex:1, align:"center", headerAlign:"center",
                valueFormatter: (params) => {
                    const formattedValue = params.value?.toLocaleString('en-US');
                    return formattedValue;
                } 
             },
             { field: "weekly1", headerName: "Week 1", flex:1, align:"center", headerAlign:"center",
                valueFormatter: (params) => {
                    const formattedValue = params.value?.toLocaleString('en-US');
                    return formattedValue;
                } 
             },
             { field: "weekly2", headerName: "Week 2", flex:1, align:"center", headerAlign:"center",
                valueFormatter: (params) => {
                    const formattedValue = params.value?.toLocaleString('en-US');
                    return formattedValue;
                } 
             },
             { field: "weekly3", headerName: "Week 3", flex:1, align:"center", headerAlign:"center",
                valueFormatter: (params) => {
                    const formattedValue = params.value?.toLocaleString('en-US');
                    return formattedValue;
                } 
             },
             { field: "weekly4", headerName: "Week 4", flex:1, align:"center", headerAlign:"center",
                valueFormatter: (params) => {
                    const formattedValue = params.value?.toLocaleString('en-US');
                    return formattedValue;
                } 
             },
             { field: "weekly5", headerName: "Week 5", flex:1, align:"center", headerAlign:"center",
                valueFormatter: (params) => {
                    const formattedValue = params.value?.toLocaleString('en-US');
                    return formattedValue;
                } 
             },
             {
                 field: "customerQuotaComments",
                 headerName: "Customer Quota Comments",
                 flex:1,
                 align:"center",
                 headerAlign:"center",
                 renderCell: (cellValues) => {
                 return <DisplayComments readonly comments={cellValues.value} />;
                 },
             },
         ];
         return columns;
    }
}

function toNum(value) {
    const n = Number(value);
    return Number.isFinite(n) ? n : 0;
}

function filterQuotaRows(rows, customerQuery, productQuery) {
    if (!rows?.length) return [];
    const c = customerQuery.trim().toLowerCase();
    const p = productQuery.trim().toLowerCase();
    return rows.filter((row) => {
        const matchCustomer =
            !c ||
            String(row.customerName ?? "")
                .toLowerCase()
                .includes(c) ||
            String(row.customerNumber ?? "")
                .toLowerCase()
                .includes(c);
        const matchProduct =
            !p ||
            String(row.skuName ?? "")
                .toLowerCase()
                .includes(p) ||
            String(row.skuNumb ?? "")
                .toLowerCase()
                .includes(p);
        return matchCustomer && matchProduct;
    });
}

function sumField(rows, field) {
    return rows.reduce((acc, row) => acc + toNum(row[field]), 0);
}

function totalSummaryValueFormatter(params) {
    return toNum(params.value).toLocaleString("en-US");
}

function getTotalSummaryColumns(periodDepletionModel) {
    const model = periodDepletionModel?.toLowerCase() ?? "";
    const numCol = (field, headerName, minWidth = 110) => ({
        field,
        headerName,
        flex: 1,
        minWidth,
        align: "center",
        headerAlign: "center",
        sortable: false,
        filterable: false,
        disableColumnMenu: true,
        valueFormatter: totalSummaryValueFormatter,
    });

    const base = [
        numCol("initialQuota", "Initial Quota", 120),
        numCol("safetyMargin", "Safety Margin", 120),
        numCol("adjustment", "Adjustment", 120),
        numCol("totalQuota", "Total Quota", 120),
    ];

    if (model === "none") {
        return base;
    }
    if (model === "biweekly") {
        return [
            ...base,
            numCol("weekly1", "First Half", 100),
            numCol("weekly2", "Second Half", 100),
        ];
    }
    return [
        ...base,
        numCol("weekly1", "Week 1", 90),
        numCol("weekly2", "Week 2", 90),
        numCol("weekly3", "Week 3", 90),
        numCol("weekly4", "Week 4", 90),
        numCol("weekly5", "Week 5", 90),
    ];
}

function TotalQuotaSummaryGrid({ periodDepletionModel, totals }) {
    const columns = useMemo(
        () => getTotalSummaryColumns(periodDepletionModel),
        [periodDepletionModel]
    );
    const summaryRows = useMemo(
        () => [
            {
                id: "__quota_totals__",
                initialQuota: totals.initialQuota,
                safetyMargin: totals.safetyMargin,
                adjustment: totals.adjustment,
                totalQuota: totals.totalQuota,
                weekly1: totals.weekly1,
                weekly2: totals.weekly2,
                weekly3: totals.weekly3,
                weekly4: totals.weekly4,
                weekly5: totals.weekly5,
            },
        ],
        [totals]
    );

    return (
        <Box sx={{ mt: 0, mb: 2 }}>
            <Typography
                variant="subtitle2"
                sx={{
                    fontWeight: 700,
                    color: "darkred.light",
                    mb: 0.75,
                }}
            >
                Total
            </Typography>
            <DataGridPro
                rows={summaryRows}
                columns={columns}
                autoHeight
                hideFooter
                disableColumnMenu
                disableColumnResize
                disableRowSelectionOnClick
                headerHeight={40}
                rowHeight={44}
                getRowId={(row) => row.id}
                sx={{
                    border: 1,
                    borderColor: "divider",
                    borderRadius: 0,
                    "& .MuiDataGrid-columnHeaders": {
                        // bgcolor: "grey.200",
                        fontWeight: 700,
                        fontSize: "0.8125rem",
                        color: "text.primary",
                    },
                    "& .MuiDataGrid-columnHeaderTitle": {
                        fontWeight: 700,
                    },
                    "& .MuiDataGrid-row": {
                        bgcolor: "background.paper",
                    },
                    "& .MuiDataGrid-cell": {
                        borderRight: "none",
                        justifyContent: "center",
                        fontSize: "0.875rem",
                    },
                    "& .MuiDataGrid-columnSeparator": {
                        display: "none",
                    },
                }}
            />
        </Box>
    );
}

export default function QuotaDetailsTable() {
	const state = useSelector((store) => store.quota);
	const { quotaDetailsTable, quotaCustomerBreakdown, quotaDetailsSearchResetKey } = state;
    const [isAll, setIsAll] = useState(false);
    const [searchCustomer, setSearchCustomer] = useState("");
    const [searchProduct, setSearchProduct] = useState("");
    const [paginationModel, setPaginationModel] = useState({
        pageSize: 20,
        page: 0
    });

	const { rows } = quotaDetailsTable;
    const columns = getColumns(quotaCustomerBreakdown.periodDepletionModel);

    const filteredRows = useMemo(
        () => filterQuotaRows(rows ?? [], searchCustomer, searchProduct),
        [rows, searchCustomer, searchProduct]
    );

    const totals = useMemo(() => {
        const initialQuota = sumField(filteredRows, "initialQuota");
        const adjustment = sumField(filteredRows, "adjustment");
        const totalQuota = sumField(filteredRows, "totalQuota");
        // Total row: Safety Margin = sum over rows of (Total Quota − Initial Quota − Adjustment)
        const safetyMargin = totalQuota - initialQuota - adjustment;
        return {
            initialQuota,
            safetyMargin,
            adjustment,
            totalQuota,
            weekly1: sumField(filteredRows, "weekly1"),
            weekly2: sumField(filteredRows, "weekly2"),
            weekly3: sumField(filteredRows, "weekly3"),
            weekly4: sumField(filteredRows, "weekly4"),
            weekly5: sumField(filteredRows, "weekly5"),
        };
    }, [filteredRows]);

    const hasSearchText =
        searchCustomer.trim().length > 0 || searchProduct.trim().length > 0;
    const showTotalSummary = hasSearchText && filteredRows.length > 0;

    useEffect(() => {
        setPaginationModel((pm) => ({ ...pm, page: 0 }));
    }, [searchCustomer, searchProduct]);

    useEffect(() => {
        setSearchCustomer("");
        setSearchProduct("");
    }, [quotaDetailsSearchResetKey]);

    const setModal = (newPaginationModel) => {
        if(newPaginationModel.pageSize === muiConfig.DataGrid_All && newPaginationModel.page === 0 && filteredRows?.length > 100){
        setIsAll(true);
        }else{
        setIsAll(false);
        }
        setPaginationModel(newPaginationModel);
    }
	return (
		<Box sx={{ mt: 5, maxWidth: "100%" }}>
            <CollapseSection title="Quota Details">
            <Grid
                container
                spacing={2}
                sx={{
                    mt: 0.5,
                    mb: 3,
                    maxWidth: { xs: "100%", sm: "50%" },
                }}
            >
                <Grid item xs={12} sm={6}>
                    <TextField
                        fullWidth
                        size="small"
                        label="Search Customer"
                        value={searchCustomer}
                        onChange={(e) => setSearchCustomer(e.target.value)}
                        variant="outlined"
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField
                        fullWidth
                        size="small"
                        label="Search Product"
                        value={searchProduct}
                        onChange={(e) => setSearchProduct(e.target.value)}
                        variant="outlined"
                    />
                </Grid>
            </Grid>
            {showTotalSummary ? (
                <TotalQuotaSummaryGrid
                    periodDepletionModel={quotaCustomerBreakdown.periodDepletionModel}
                    totals={totals}
                />
            ) : null}
			<DataGridPro //style={{ maxHeight: 'calc(100vh - 130px)'}}
            rows={filteredRows}
            columns={columns}
            disableColumnMenu
            initialState={{
                pagination: { paginationModel: { pageSize:20, page:0 }}
            }}
            pagination
            pageSizeOptions={[20, 50, 100, { value: muiConfig.DataGrid_All , label: 'All' }]}
            paginationModel={paginationModel}
            onPaginationModelChange = {setModal}
            headerHeight={40}
            sx={{
                marginTop: 0,
                ...(!isAll ? {
                    "& .MuiDataGrid-virtualScroller": {
                       maxHeight: "unset !important"
                    }
                  } : {
                    "& .MuiDataGrid-virtualScroller": {
                       maxHeight: "80vh !important"
                    }
                })
            }}
         />
         </CollapseSection>
		</Box>
	);
}
